import { watch, onBeforeMount, onUnmounted, onDeactivated, onActivated, getCurrentInstance } from 'virtual-vue';
import { createNamespace } from '../utils/components';

const { n } = createNamespace('');

const context = {
  locks: {},
};

export function resolveLock() {
  const lockCounts = Object.keys(context.locks).length;
  lockCounts <= 0 ? document.body.classList.remove(n('$--lock')) : document.body.classList.add(n('$--lock'));
}

export function addLock(uid: number) {
  context.locks[uid] = 1;
  resolveLock();
}

export function releaseLock(uid: number) {
  delete context.locks[uid];
  resolveLock();
}

/**
 * 状态锁
 * @param source
 * @param useSource
 */
export function useLock(source: any, useSource?: any) {
  const { uid } = getCurrentInstance()!;

  if (useSource) {
    watch(useSource, (newValue: boolean) => {
      if (newValue === false) {
        // 释放锁
        releaseLock(uid);
      } else if (newValue === true && source() === true) {
        // 添加锁
        addLock(uid);
      }
    });
  }

  watch(source, (newValue: boolean) => {
    // 如果传入了useSource，且useSource得值为false，则不添加锁
    if (useSource && useSource() === false) {
      return;
    }

    if (newValue === true) {
      addLock(uid);
    } else {
      releaseLock(uid);
    }
  });

  onBeforeMount(() => {
    if (useSource && useSource() === false) {
      return;
    }

    if (source() === true) {
      addLock(uid);
    }
  });

  onUnmounted(() => {
    if (useSource && useSource() === false) {
      return;
    }

    if (source() === true) {
      releaseLock(uid);
    }
  });

  onActivated(() => {
    if (useSource && useSource() === false) {
      return;
    }

    if (source() === true) {
      addLock(uid);
    }
  });

  onDeactivated(() => {
    if (useSource && useSource() === false) {
      return;
    }

    if (source() === true) {
      releaseLock(uid);
    }
  });
}
